export default __webpack_public_path__ + "static/media/flop-types_0005_thumb.1e3b09e6.jpg";